export default "__VITE_ASSET__BlvNNabE__"